import React, { useMemo, useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import FeedbackModal from "./FeedbackModal";

export default function FeedbackTab() {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  const pageUrl = useMemo(() => {
    if (typeof window === "undefined") return "";
    return `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
  }, [location]);

  const attachedTransform = isMobile
    ? "translateY(-50%) rotate(-90deg)"
    : "translateY(-50%) rotate(-90deg)";

  const attachedHoverTransform = isMobile
    ? "translateY(-50%) rotate(-90deg) translateX(-1px)"
    : "translateY(-50%) rotate(-90deg) translateX(-2px)";

  return (
    <>
      <Box
        role="button"
        tabIndex={0}
        aria-label="Open feedback form"
        onClick={() => setOpen(true)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            setOpen(true);
          }
        }}
        sx={{
          position: "fixed",
          zIndex: (t) => t.zIndex.drawer + 12,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          right: isMobile ? -30 : -34,
          top: isMobile ? "58%" : "50%",
          bottom: "auto",
          transform: attachedTransform,
          transformOrigin: "center",
          px: isMobile ? 1.35 : 2.2,
          py: isMobile ? 0.95 : 1.15,
          minWidth: isMobile ? 104 : 124,
          borderRadius: "14px 14px 0 0",
          backgroundColor: theme.palette.info.main,
          color: theme.palette.info.contrastText,
          boxShadow: isMobile
            ? "0px 10px 24px rgba(0,0,0,0.18)"
            : "0px 14px 30px rgba(0,0,0,0.18)",
          border: "1px solid rgba(255,255,255,0.12)",
          cursor: "pointer",
          userSelect: "none",
          transition: "transform 180ms ease, box-shadow 180ms ease, background-color 180ms ease",
          WebkitTapHighlightColor: "transparent",
          "&:hover": {
            backgroundColor: theme.palette.info.dark,
            boxShadow: isMobile
              ? "0px 12px 26px rgba(0,0,0,0.22)"
              : "0px 16px 34px rgba(0,0,0,0.22)",
            transform: attachedHoverTransform,
          },
          "&:focus-visible": {
            outline: "3px solid rgba(30,58,95,0.22)",
            outlineOffset: 2,
          },
        }}
      >
        <Typography
          variant="button"
          sx={{
            display: "block",
            fontSize: isMobile ? "0.76rem" : "0.88rem",
            letterSpacing: "0.05em",
            fontWeight: 700,
            lineHeight: 1,
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          Feedback
        </Typography>
      </Box>

      <FeedbackModal
        open={open}
        onClose={() => setOpen(false)}
        pageUrl={pageUrl}
      />
    </>
  );
}
